<app-medshorts-contact *ngIf="isMedshorts"></app-medshorts-contact>
